import React from 'react';
import { Button, Dropdown, Layout } from 'antd';
import { DownOutlined } from '@ant-design/icons';
// import Avatar from "../../../../assets/images/user.png";
import useStore from '../../../../store';
import { observer } from 'mobx-react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { MainBreadcumrs } from '../../../../config/BreadcrumbConfig';
import { MenuFoldOutlined } from '@ant-design/icons';

const AppHeaderView = observer(({ collapsed, SetCollapsed }) => {
	const { pathname } = useLocation();
	const { AUTH } = useStore();
	const { doLogout, user } = AUTH;
	const navigate = useNavigate();

	// call logout function
	const logout = () => {
		doLogout().then(() => {
			navigate('/login');
		});
	};

	const items = [
		{ label: <div onClick={() => logout()}>Logout</div>, key: 'Logout' },
	];

	return (
		<Layout.Header className="main__page__appheader">
			<div className="headerWrap">
				<div className="appheader__left">
					{/* {visible ? ( */}
					<div className="menuToggle">
						{collapsed ? (
							<div
								className="icon right"
								onClick={() => SetCollapsed(!collapsed)}
							>
								<MenuFoldOutlined />
							</div>
						) : (
							<div
								className="icon"
								onClick={() => SetCollapsed(!collapsed)}
							>
								<MenuFoldOutlined />
							</div>
						)}
					</div>
					{/* <BreadcrumbComponent items={DashboardBreadcrumb.path} /> */}
					<MainBreadcumrs currentPath={pathname} />
				</div>
				<div className="appheader__right">
					<div className="userDropdown">
						<Dropdown
							menu={{ items, selectable: true }}
							dropdownRender={() => (
								<>
									<Link
										to="/profile"
										className="dropdown-content"
									>
										Profile
									</Link>
									<Button
										type="link"
										to="/profile"
										className="dropdown-content"
										onClick={logout}
									>
										Logout
									</Button>
								</>
							)}
							overlayClassName="userMenuList"
						>
							<div className="userMenuWrap">
								{/* <span className="avatar">
									<img src={Avatar} alt="Avatar" />
								</span> */}
								<span className="userName">
									{user &&
										user.firstName + ' ' + user.lastName}
								</span>
								<DownOutlined />
							</div>
						</Dropdown>
					</div>
				</div>
			</div>
		</Layout.Header>
	);
});

export default AppHeaderView;
